import { ReactNode, useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePermission } from '../../hooks/usePermission';
import { LoadingSpinner } from './Loading';

interface PermissionRouteProps {
  /** 命中其中任一权限即放行；空数组或缺省视为公开（仅做登录校验） */
  permissions?: string[];
  requireAll?: boolean;
  children: ReactNode;
}

export default function PermissionRoute({
  permissions,
  requireAll = false,
  children,
}: PermissionRouteProps) {
  const { permissionInfo, loading, hasAnyPermission, hasAllPermissions } = usePermission();
  const location = useLocation();

  const allowed = useMemo(() => {
    if (!permissions || permissions.length === 0) return true;
    if (!permissionInfo) return false;
    if (permissionInfo.user?.is_superuser) return true;
    return requireAll ? hasAllPermissions(permissions) : hasAnyPermission(permissions);
  }, [permissions, requireAll, permissionInfo, hasAnyPermission, hasAllPermissions]);

  if (loading && !permissionInfo) {
    return <LoadingSpinner size="lg" color="cyan" text="校验权限..." />;
  }
  if (!allowed) {
    return <Navigate to="/403" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
